
// import {DatePicker} from 'Electron Gateway_react_ui'
import '@/assets/css/animate.min.css'
// import 'Electron Gateway_react_ui/dist/app.css';
import { BrowserRouter, Route, Router, Routes, useRoutes,useLocation,useSearchParams } from 'react-router-dom'
import { Suspense,useEffect, useState } from 'react'
import route from './route'
import NavBar from '@/components/NavBar'
import BottomPage from '@/components/BottomPage'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { fetch } from './utils/common';
import './App.css';
function App() {
  const RouteRender = () => {
    const rs = useRoutes(route)
    const location = useLocation()
    useEffect(() => {
      if (document && location?.pathname.indexOf('product')===-1) {  // 可以排除不需要置顶的页面
        if (document?.documentElement || document?.body) {
          document.documentElement.scrollTop = document.body.scrollTop = 0;  // 切换路由时手动置顶
        }
      }
    }, [location?.pathname]);
    const [params] = useSearchParams();
    const id = params.get('id')||''
      useEffect(() => {
        if(id){
          setTimeout(() => {
          anchorScroll(id);
            
          }, 10);
        }
      }, [id]);
    return rs
  }
  const [navList,setNav] = useState([])

  const anchorScroll = (id) => {
    let anchorElement = document.getElementById(id);
    console.log('=====',anchorElement)
    // 如果对应id的锚点存在，就跳转到锚点
    
    if (anchorElement) {
      anchorElement.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  };
  useEffect(()=>{
    // getNavList()
  },[])
  return (
    <div className="App">
      <BrowserRouter>
        <NavBar list={navList} />
        <div className='app_warp'>
          <Suspense fallback={() => <div className='loading'></div>}>
            <RouteRender></RouteRender>
          </Suspense>
        </div>

        <BottomPage />
      </BrowserRouter>

    </div>
  );
}

export default App;
